import { useQuery } from "@tanstack/react-query"

import { getPrayerSchedule } from "api/prayerTimeApi"

export const PRAYER_SCHEDULE_QUERY_KEY = "prayer-schedule"

export const usePrayerSchedule = (params = {}, enabled = true) =>
  useQuery({
    queryKey: [PRAYER_SCHEDULE_QUERY_KEY, params],
    queryFn: () => getPrayerSchedule(params),
    enabled,
    keepPreviousData: true,
    staleTime: 5 * 60 * 1000,
  })
